import request from '@/service/index'

// 获取c端微信签名
export function getCWXSignature () {
  const url = window.location.href.split('#')[0]
  // let url = `https://luojigou.vip/app_web`;
  return request({
    url: 'app/wx/sign',
    method: 'GET',
    params: { url }
  })
}

// 获取家长端微信签名
export function getParentWXSignature () {
  const url = window.location.href.split('#')[0]
  return request({
    url: 'app/wx/sign/parent',
    method: 'GET',
    params: { url }
  })
}

// 短信登录
export function smsLogin (phone: string, code: string) {
  return request({
    url: `app/sms/checkCode/app/${phone}/${code}`,
    method: 'POST'
  })
}

// 根据手机号获取验证码
export function getSmsByPhone (phone: string) {
  return request({
    url: `app/sms/getCode/${phone}`,
    method: 'GET'
  })
}

// 领取vip
export function collectCoursePackage (vipType: number) {
  return request({
    url: `app/ai/course/vip/add/${vipType}`,
    method: 'POST'
  })
}

// 领取课程包
export function addAiCourse () {
  return request({
    url: 'app/ai/course/vip/addAiCourse',
    method: 'POST'
  })
}

// 获取课程包详情
export function getAiCourseInfo () {
  return request({
    url: 'app/ai/course/vip/getAiCourseInfo',
    method: 'GET'
  })
}

/**
 * @description H5网页短信验证码登录
 * @param {string} phone - 手机号
 * @param {string} code - 验证码
 * @returns {Promise}
 */
export function loginBySMS (phone: string, code: string) {
  return request({
    url: `mall/mobile/login/SMS/${phone}/${code}`,
    method: 'POST'
  })
}
